<template>
  <div class="w-full flex flex-col justify-center items-center gap-10">
    <Wrapper class="max-w-2xl">
      <h2 class="text-2xl text-left text-blue-dark mb-2">
        <b>Detalle de la solicitud</b>
      </h2>
      <ComplaintEmisorDetailHeaderCard
        :code="solicitude.code"
        :status="solicitude.status_solip"
      />
      <form
        ref="formSolicitudeCF"
        @submit.prevent="sendComplaint"
        class="w-full px-0 py-0"
      >
        <!-- Persona natural -->
        <div
          class="w-full"
          v-if="solicitude.user_cf && solicitude.user_cf.tipo_persona == 1"
        >
          <h2 class="my-5 text-lg text-left text-blue">
            <b>Datos de contacto</b>
          </h2>
          <BaseInput
            type="text"
            label="Nombres"
            v-model="solicitude.user_cf.names_cf"
            placeholder="Julio Roman"
            :disabled="true"
          />
          <BaseInput
            type="text"
            label="Apellidos"
            v-model="solicitude.user_cf.surnames_cf"
            placeholder="Henriquez"
            :disabled="true"
          />
          <BaseInput
            type="text"
            label="Tipo de identificación"
            v-model="solicitude.user_cf.identification_type_cf"
            placeholder="C.C"
            :disabled="true"
          />
          <BaseInput
            type="text"
            label="Número de identificación"
            placeholder="Ej:123456789"
            v-model="solicitude.user_cf.numero_id_cf"
            :disabled="true"
          />
          <BaseInput
            type="text"
            label="Fecha de nacimiento"
            v-model="solicitude.user_cf.birth_date_user"
            placeholder="11/11/2011"
            :disabled="true"
          />
          <BaseInput
            type="text"
            label="Número de celular"
            placeholder="123412341234"
            v-model="solicitude.user_cf.phone_user"
            :disabled="true"
          />
          <BaseInput
            ref="email"
            type="text"
            label="Correo electrónico"
            v-model="solicitude.user_cf.email_user"
            placeholder="ejemplo@ejemplo.com"
            required="true"
            autocomplete="username"
            :disabled="true"
          />

          <BaseSelect
            ref="department"
            id="department"
            label="Seleccione un departamento"
            :selectOptions="formOptions.optionsDepartments"
            v-model="solicitude.user_cf.departamento_nombre_user"
            :disabled="true"
            v-if="solicitude.user_cf.departamento_nombre_user"
          />
          <BaseSelect
            ref="city"
            id="city"
            label="Seleccione un municipio"
            :selectOptions="optionsMunicipalities2"
            v-model="solicitude.user_cf.municipio_nombre_user"
            :disabled="true"
            v-if="solicitude.user_cf.municipio_nombre_user"
          />
          <BaseInput
            ref="address"
            id="address"
            label="Dirección"
            v-model="solicitude.user_cf.direccion_user"
            :maxlength="50"
            placeholder="Cra. 1 ## 1A-11"
            type="text"
            v-if="solicitude.user_cf.direccion_user"
            :disabled="true"
          />
        </div>
        <!-- Persona júridica -->
        <div
          class="w-full"
          v-if="solicitude.user_cf && solicitude.user_cf.tipo_persona == 2"
        >
          <h2 class="my-5 text-lg text-left text-blue">
            <b>Datos de contacto</b>
          </h2>
          <BaseInput
            type="text"
            label="Nombres del representante legal"
            v-model="solicitude.user_cf.names_cf"
            placeholder="Julio Roman"
            :disabled="true"
          />
          <BaseInput
            type="text"
            label="Apellidos del representante legal"
            v-model="solicitude.user_cf.surnames_cf"
            placeholder="Henriquez"
            :disabled="true"
          />
          <BaseInput
            ref="nit"
            type="text"
            id="nit"
            label="NIT"
            v-model="solicitude.user_cf.numero_id_cf"
            :disabled="true"
            v-if="solicitude.user_cf.numero_id_cf"
          />
          <BaseInput
            ref="company_name"
            type="text"
            id="razonSocial"
            label="Razón social"
            v-model="solicitude.user_cf.business_name"
            :disabled="true"
            v-if="solicitude.user_cf.business_name"
          />
          <BaseInput
            type="text"
            label="Número de celular"
            placeholder="123412341234"
            v-model="solicitude.user_cf.phone_user"
            :disabled="true"
          />
          <BaseInput
            ref="email"
            type="text"
            label="Correo electrónico"
            v-model="solicitude.user_cf.email_user"
            placeholder="ejemplo@ejemplo.com"
            required="true"
            autocomplete="username"
            :disabled="true"
          />

          <BaseSelect
            ref="department"
            id="department"
            label="Seleccione un departamento"
            :selectOptions="formOptions.optionsDepartments"
            v-model="solicitude.user_cf.departamento_nombre_user"
            :disabled="true"
            v-if="solicitude.user_cf.departamento_nombre_user"
          />
          <BaseSelect
            ref="city"
            id="city"
            label="Seleccione un municipio"
            :selectOptions="optionsMunicipalities2"
            v-model="solicitude.user_cf.municipio_nombre_user"
            :disabled="true"
            v-if="solicitude.user_cf.municipio_nombre_user"
          />
          <BaseInput
            ref="address"
            id="address"
            label="Dirección"
            v-model="solicitude.user_cf.direccion_user"
            :maxlength="50"
            placeholder="Cra. 1 ## 1A-11"
            type="text"
            v-if="solicitude.user_cf.direccion_user"
            :disabled="true"
          />
        </div>
        <div v-if="solicitude.user_cf && solicitude.user_cf.tipo_persona == 1">
          <BaseInput
            type="text"
            label="Sexo"
            v-model="solicitude.user_cf.sexo_nombre"
            :disabled="true"
            v-if="solicitude.user_cf.sexo_nombre"
          />
          <BaseRadio
            ref="lgtbiq"
            name="lgtbiq"
            label="LGTBIQ+"
            :disabled="true"
            :radioOptions="optionsYN"
            v-model="solicitude.user_cf.lgbtiq"
          />
          <BaseRadio
            ref="especialCondicion"
            name="especialCondicion"
            label="¿Tiene alguna condición especial?"
            :disabled="true"
            :radioOptions="optionsYN"
            :value="specialCondition"
            v-if="specialCondition !== ''"
          />
          <BaseSelect
            ref="typeSpecialCondition"
            v-if="specialCondition == 1"
            id="typeSpecialCondition"
            label="¿Cuál?"
            :disabled="true"
            :selectOptions="formOptions.optionsConditions"
            v-model="solicitude.user_cf.condicion_especial"
            required="true"
          />
        </div>
        <h2 class="my-5 text-xl text-left text-blue">
          <b>Detalles de la inconformidad</b>
        </h2>
        <BaseRadio
          label="¿La inconformidad que motiva su queja ocurrió el exterior?"
          :radioOptions="optionsYN"
          :value="solicitude.places.codigo_pais == '170' ? 2 : 1"
          required="true"
          :disabled="true"
        />
        <div v-if="solicitude.places.codigo_pais == '170'">
          <BaseSelect
            ref="department"
            id="department"
            label="Seleccione un departamento"
            :disabled="true"
            :selectOptions="formOptions.optionsDepartments"
            v-model="solicitude.places.departamento_nombre"
            required="true"
          />
          <BaseSelect
            ref="city"
            id="city"
            label="Seleccione un municipio"
            :selectOptions="optionsMunicipalities"
            v-model="solicitude.places.municipio_nombre"
            required="true"
            :disabled="true"
          />
        </div>
        <div v-if="solicitude.places.codigo_pais != '170'">
          <BaseSelect
            ref="country"
            id="country"
            label="Seleccione el país donde ocurrio la incidencia"
            :disabled="true"
            :selectOptions="formOptions.optionsCountries"
            v-model="solicitude.places.pais_nombre"
            required="true"
          />
        </div>
        <BaseSelect
          ref="entity"
          id="entity"
          label="¿Con qué entidad tuvo su inconformidad?"
          :disabled="true"
          :selectOptions="formOptions.optionsCompanyEmisor"
          v-model="solicitude.entidad.company_name"
          required="true"
        />

        <BaseSelect
          ref="typeValueEmisor"
          id="typeValueEmisor"
          :disabled="true"
          label="¿Cuál es el tipo de valor relacionado a la inconformidad?"
          :selectOptions="formOptions.optionsTypeValueEmisor"
          v-model="solicitude.type_value"
          required="true"
        />
        <BaseSelect
          ref="reason"
          id="reason"
          label="¿Cuál es el motivo de su inconformidad?"
          :selectOptions="optionsReasons"
          v-model="solicitude.detalle_solicitud.motivo_nombre"
          required="true"
          :disabled="true"
        />

        <BaseTextarea
          ref="describe"
          id="describe"
          label="Haga un relato cronológico de los hechos que fundamentan su solicitud, de manera clara, numerando cada uno de ellos y de ser posible, especificando circunstancias de tiempo, modo y lugar."
          :disabled="true"
          placeholder="Mensaje"
          v-model="solicitude.detalle_solicitud.texto_queja"
          required="true"
          maxlength="4500"
        />

        <BaseRadio
          ref="attorney"
          name="apoderado"
          label="¿Actúa en nombre propio o es apoderado del inversionista?"
          :radioOptions="optionsApoderado"
          v-model="solicitude.es_apoderado"
          required="true"
          :disabled="true"
        />
        <div v-if="solicitude.es_apoderado == 2" class="w-full">
          <BaseInput
            ref="attorneyName"
            type="text"
            id="apoderadoName"
            label="Nombre completo del apoderado:"
            placeholder="Ej: Lina Maria De Castro Jaramillo"
            v-model="solicitude.apoderado.nombres"
            required="true"
            :disabled="true"
          />
          <BaseInput
            ref="attorneyEmail"
            type="text"
            label="Correo electrónico del apoderado"
            v-model="solicitude.apoderado.correo"
            placeholder="ejemplo@ejemplo.com"
            required="true"
            autocomplete="username"
            :disabled="true"
          />

          <div class="flex flex-col gap-2">
            <label
              class="text-xs md:text-xs text-gray-600 text-opacity-80 mt-5 text-left"
              ><b>Anexar autorización del poder</b></label
            >
            <div class="w-11/12 grid grid-cols-1 gap-2">
              <ComplaintEmisorDownloadAttachment
                v-for="(option, index) in anexos_apoderado"
                :value="option"
                :file_name="option.file_name"
                :key="index"
              />
            </div>
          </div>
        </div>

        <template v-if="anexos_queja && anexos_queja.length > 0">
          <ComplaintEmisorAnnexes
            :title_accordion="'Anexos de la solicitud'"
            :attachments="anexos_queja"
            class="mt-6 px-0"
          />
        </template>

        <div class="mt-2 flex flex-col gap-4 w-full">
          <div class="flex flex-col gap-2">
            <label
              class="text-xs md:text-xs text-gray-600 text-opacity-80 mt-5 text-left"
              ><b>Documento cero</b></label
            >
            <div class="w-11/12 grid grid-cols-1 gap-2">
              <ComplaintEmisorDownloadAttachment
                v-for="(option, index) in anexo_documento_cero"
                :value="option"
                :file_name="option.file_name"
                :key="index"
              />
            </div>
          </div>

          <div v-if="solicitude.solip && solicitude.solip.estado_solip_nombre">
            <h2 class="mt-8 text-lg text-left text-blue">
              <b>Radicación SOLIP</b>
            </h2>
            <BaseInput
              type="text"
              label="Número de radicación en SOLIP"
              :value="solicitude.solip.radicado_solip"
              :disabled="true"
            />

            <BaseInput
              type="text"
              label="Fecha de rádicación"
              :value="formatDateToText(solicitude.solip.fecha_radicacion)"
              :disabled="true"
            />
            <div
              v-if="solicitude.solip.estado_solip_nombre != 'Radicada'"
              class="w-full my-8 grid grid-cols-2 gap-6"
            >
              <div class="h-auto w-full items-center flex flex-row">
                <label class="text-gray-500 text-opacity-80"
                  >Estado de radicación</label
                >
                <button
                  class="flex text-xs items-baseline ml-2 text-blue h-min"
                  @click="retryRadicadoSolip(solicitude.code)"
                >
                  <a-icon
                    type="reload"
                    :style="{ fontSize: '19px', color: '#3366cc' }"
                  />
                </button>
              </div>
            </div>
            <BaseSelect
              label="Estado de radicación"
              :selectOptions="formOptions.optionsStatesEmisor"
              :value="solicitude.solip.estado_solip_nombre"
              :disabled="true"
            />

            <BaseTextarea
              label="Detalle de radicación"
              placeholder=""
              :value="solicitude.solip.detalle_solip"
              maxlength="100"
              rows="2"
              :disabled="true"
            />
            <BaseSelect
              label="Estado de radicación de anexos"
              :selectOptions="formOptions.optionsStatesEmisor"
              :value="solicitude.solip.estado_solip_anexes_nombre"
              :disabled="true"
            />
          </div>
          <div
            v-if="solicitude.solip && anexos_queja && anexos_queja.length > 0"
          >
            <h2 class="mt-8 text-lg text-left text-blue">
              <b>Radicación de anexos en SOLIP</b>
            </h2>
            <template v-for="annexe in anexos_queja">
              <BaseInput
                type="text"
                label="Nombre del anexo"
                v-model="annexe.file_name"
                :disabled="true"
              />
              <div
                v-if="annexe.estado_solip_nombre != 'Radicada'"
                class="w-full my-8 grid grid-cols-2 gap-6"
              >
                <div class="h-auto w-full items-center flex flex-row">
                  <label class="text-gray-500 text-opacity-80"
                    >Estado de radicación de anexo</label
                  >
                  <button
                    class="flex text-xs items-baseline ml-2 text-blue h-min"
                    @click="
                      retryRadicadoSolipAnexes(solicitude.code, annexe.id)
                    "
                  >
                    <a-icon
                      type="reload"
                      :style="{ fontSize: '19px', color: '#3366cc' }"
                    />
                  </button>
                </div>
              </div>
              <BaseSelect
                label="Estado de radicación de anexos"
                :selectOptions="formOptions.optionsStatesEmisor"
                :value="annexe.estado_solip_nombre"
                :disabled="true"
              />
              <BaseTextarea
                label="Detalle de radicación de anexo"
                :value="annexe.detalle_solip"
                maxlength="1000"
                rows="2"
                :disabled="true"
              />
              <hr class="w-full my-3" />
            </template>
          </div>
          <br />
        </div>
        <div
          v-if="loading"
          class="fixed inset-0 flex justify-center items-center"
        >
          <a-spin tip="Cargando..." size="large"> </a-spin>
        </div>
      </form>
    </Wrapper>
  </div>
</template>

<script>
import ComplaintEmisorAnnexes from "@/feature/dashboard/complaints_emisor/presentation/partials/ComplaintEmisorAnnexes";
import ComplaintEmisorDownloadAttachment from "@/feature/dashboard/complaints_emisor/presentation/partials/ComplaintEmisorDownloadAttachment";
import ComplaintEmisorDetailHeaderCard from "@/components/Dashboard/Complaints/ComplaintEmisorDetailHeaderCard";
import moment from "moment";
import "moment/locale/es";
import { values } from "lodash";
import complaintsEmisorServicesImplementation from "@/feature/dashboard/complaints_emisor/data/services/complaints_emisor_services_impl";
import ErrorMessaje from "@/core/error/error_messaje";

const columns = [
  {
    title: "Nombre completo",
    dataIndex: "full_name",
    key: "full_name",
    width: 120,
  },
  {
    title: "Tipo de identificación",
    dataIndex: "identification_type_nombre",
    key: "identification_type_nombre",
    width: 120,
  },
  {
    title: "Numero de identificación",
    dataIndex: "identification_number",
    key: "identification_number",
    width: 120,
  },
];
export default {
  props: ["complaint", "customer"],
  components: {
    ComplaintEmisorDetailHeaderCard,
    ComplaintEmisorDownloadAttachment,
    ComplaintEmisorAnnexes,
  },
  data() {
    return {
      solicitude: {
        user_cf: {},
        anexos: [],
        places: {},
        entidad: {},
        detalle_solicitud: {},
        apoderado: {},
      },
      plainOptions: [
        {
          title: "Conciliación:",
          subtitle: `Será convocado para que asista a una audiencia junto con la entidad para buscar una solución a su inconformidad, con la participación de un Conciliador de la Superfinanciera.`,
          value: "2",
        },
        {
          title: "Demanda:",
          subtitle: `Se adelanta un proceso con un funcionario de la Superfinanciera quien actúa como Juez entre usted y la entidad para decidir sobre su inconformidad.`,
          value: "1",
        },
        {
          title: "Queja:",
          subtitle: `Su solicitud será atendida directamente por la entidad financiera.`,
          value: "0",
        },
      ],
      optionsForm: [false, false, false],
      modalVisible: false,
      evidences: {
        conciliation: {
          url: null,
          folder: null,
        },
        demand: {
          url: null,
          folder: null,
        },
      },
      cuantiaYN: 2,
      ops: [],
      feedback: "",
      abroad: "",
      specialCondition: "",
      complaintFiles: [],
      general_references: "!,2,6,7,8,9",
      authorizationFiles: [],
      filesSize: 0,
      optionsMunicipalities: [],
      optionsMunicipalities2: [],
      optionsReasons: [],
      optionsProducts: [],
      optionsYN: [
        { id: 1, name: "Sí" },
        { id: 2, name: "No" },
      ],
      optionsApoderado: [
        { id: 1, name: "Actúo en nombre propio" },
        { id: 2, name: "Soy apoderado" },
      ],
      disableButton: false,
      loading: false,
      loadingModal: false,
      currentStepFile: 0,
      stepStyle: {
        boxShadow: "0px -1px 0 0 #e8e8e8 inset",
      },
      anexos_apoderado: [],
      anexo_documento_cero: [],
      anexos_queja: [],
      archivos_apoderado: [],
      archivo_cero: [],
      archivos_solicitude: [],
      columns,
      otros_demandantes: [],
      solicitudes: "",
      juramento_estimatorio: "",
    };
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
    user: function () {
      let user = this.$store.state.session.user;
      return user;
    },
  },
  async created() {
    await this.getcomplaintsEmisorDetail();
  },
  methods: {
    async getcomplaintsEmisorDetail() {
      this.loading = true;
      const id = this.$route.params.id;

      try {
        const response =
          await complaintsEmisorServicesImplementation.getComplaintEmisorDetail(
            id
          );

        if (response.isSuccess) {
          const data = response.data;
          this.solicitude.code = data.codigo_queja;
          this.solicitude.status_solip =
            data.emisores_solip.estado_solip_nombre;
          this.solicitude.user_cf = data.user_cf;
          this.solicitude.user_cf.municipio_nombre_user =
            this.solicitude.user_cf.municipio_nombre_user == "null"
              ? ""
              : this.solicitude.user_cf.municipio_nombre_user;
          this.solicitude.user_cf.direccion_user =
            this.solicitude.user_cf.direccion_user == "null"
              ? ""
              : this.solicitude.user_cf.direccion_user;

          let condicion_especial = this.solicitude.user_cf.condicion_especial;
          this.specialCondition =
            condicion_especial === null
              ? ""
              : condicion_especial == "98"
              ? 2
              : 1;

          if (this.solicitude.user_cf.sexo) {
            const genderOptions = [...this.formOptions.optionsGender];
            const genderUser = genderOptions.find(
              (item) => item.id === this.solicitude.user_cf.sexo
            );
            this.solicitude.user_cf.sexo_nombre = genderUser.name;
          }

          this.solicitude.places = data.places;
          this.solicitude.entidad.company_name = data.entidad.company_name;
          this.solicitude.type_value = data.detalle_solicitud.tipo_valor_nombre;
          this.solicitude.detalle_solicitud.motivo_nombre =
            data.detalle_solicitud.motivo_nombre;
          this.solicitude.detalle_solicitud.texto_queja =
            data.detalle_solicitud.texto_queja;

          this.solicitude.es_apoderado = data.detalle_solicitud.es_apoderado
            ? 2
            : 1;
          this.solicitude.apoderado.nombres = data.apoderado.apoderado_nombre;
          this.solicitude.apoderado.correo = data.apoderado.apoderado_correo;

          this.anexos_apoderado = data.anexos.filter(
            (anexo) => anexo.reference_nombre === "Apoderado"
          );
          this.anexos_queja = data.anexos.filter(
            (anexo) => anexo.reference_nombre === "Anexo Queja"
          );
          this.anexo_documento_cero = data.anexos.filter(
            (anexo) => anexo.reference_nombre === "Documento Cero"
          );

          this.solicitude.solip = data.emisores_solip;

          this.loading = false;
          return;
        } else {
          this.showToast("error", ErrorMessaje.generalError);
          this.loading = false;
          return;
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
        this.loading = false;
        return;
      }
    },

    loadedFile() {
      this.loadingModal = false;
    },
    sendComplaint() {},
    formatDateToText(date) {
      const momentDate = moment(date);
      if (!date || !momentDate.isValid()) {
        return "";
      }
      return momentDate.locale("es").format("D [de] MMMM [de] YYYY, HH:mm:ss");
    },
    async retryRadicadoSolip(codigoQueja) {
      this.loading = true;

      const data = {
        codigo_queja: codigoQueja,
      };

      try {
        const response =
          await complaintsEmisorServicesImplementation.retryFilingSolip(
            codigoQueja,
            data
          );

        if (response.isSuccess) {
          this.$router.go(0);
          return;
        } else {
          let errorMessage = ErrorMessaje.generalError;
          if (response.data && response.data.error) {
            errorMessage = response.data.error;

            if (response.data && response.data.detail) {
              errorMessage = errorMessage + " - " + response.data.detail;
            }
          }
          this.showToast("error", errorMessage);
          return;
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.loading = false;
      }
    },
    async retryRadicadoSolipAnexes(codigoQueja, idAnexo) {
      this.loading = true;

      const data = {
        codigo_queja: codigoQueja,
        id_anexo: idAnexo,
      };

      try {
        const response =
          await complaintsEmisorServicesImplementation.retryFilingSolipAnexes(
            codigoQueja,
            idAnexo,
            data
          );

        if (response.isSuccess) {
          this.$router.go(0);
          return;
        } else {
          let errorMessage = ErrorMessaje.generalError;
          if (response.data && response.data.error) {
            errorMessage = response.data.error;

            if (response.data && response.data.detail) {
              errorMessage = errorMessage + " - " + response.data.detail;
            }
          }
          this.showToast("error", errorMessage);
          return;
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.loading = false;
      }
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
  },
  watch: {},
};
</script>
